import MediaImage from "@/components/ui/MediaImage";
import React, { useEffect, useState } from "react";
import { usePreviewMode } from "./PreviewMode";

interface ZoomImageProps {
  images: { mdUrl?: string; xlUrl?: string; namespace: string }[];
}

const RandomImage: React.FC<ZoomImageProps> = ({ images }) => {
  const [randomImageUrl, setRandomImageUrl] = useState<string | null>(null);
  // The preview draws the section anew on every change, so a random photo would change with every setting.
  const preview = !!usePreviewMode();

  useEffect(() => {
    if (images.length === 1) {
      const url = images[0]?.xlUrl;
      if (url) {
        setRandomImageUrl(url);
      }
    }
    if (images.length > 0) {
      const randomIndex = Math.floor(Math.random() * images.length);
      const url = images[randomIndex]?.xlUrl;
      if (url) {
        setRandomImageUrl(url);
      }
    }
  }, []);

  const imageUrl = preview ? (images[0]?.xlUrl ?? null) : randomImageUrl;

  return imageUrl ? (
    <MediaImage
      src={imageUrl}
      alt="Case Image"
      className="object-cover w-full h-full homepage-image-rounded"
    />
  ) : null;
};

export default RandomImage;
